export default __webpack_public_path__ + "static/media/resorttitle.aa9a688b.jpg";